/**
 * api routes details
 * @author damith
 */

const ApiRoutes = {
  // AUTH
  SIGN_IN: "/auth/sign-in",

  //CATEGORY
  CREATE_CATEGORY: "/categories/create/new",
  GET_ALL_CATEGORY: "/categories/get/all",

  GET_CATEGORY: "/categories/get/by",
  UPDATE_CATEGORY: "/categories/update/by",

  // MENU
  CREATE_MENUS: "/create/new/menu",
  GET_ALL_MENUS: "/get/all/news/menu",
  UPDATE_MENU: "/update/news/menu",

  // NEWS
  CREATE_NEWS: "/news/create",
  UPDATE_NEWS: "/update/news/article",
  ADD_UPDATE_NEWS: "/add/update/news/article",
  ADD_NEWS_COMMENT: "/add/comment",
  CHANGE_NEWS_COMMENT_LIKE: "/change/comment/like",
  UPDATE_COMMENT_STATUS: "update/news/comment",
  DELETE_NEWS_COMMENT: "delete/news/comment/by",
  GET_NEWS: "/news/get/by",
  GET_NEWS_BY_CATEGORY: "/get/by",
  GET_NEWS_BY_PAGE: "/get/news",
  GET_SUGGESTIONS_NEWS: "/get/suggestions/news/by",
  GET_NEWS_BY_CATEGORY_BY_PAGE: "/get/news/by",
  GET_NEWS_BY_TAG: "/get/all/news/by/tag",
  GET_NEWS_BY_WIDGET: "/get/all/news/by/widget",
  GET_NEWS_BY_TOP_TAGS: "/get/top/tags/news",
  GET_NEWS_BY_TAGS: "/get/related/news",
  GET_TRENDING_NEWS: "/get/trending/news",
  GET_ALL_NEWS: "/get/all/news",
  GET_NEWS_BULLETS: "/get/news/bullets",
  GET_NEXT_NEWS: "/get/next/news",
  DEACTIVATE_NEWS: "/update/news/status",
  GET_ALL_PAST_NEWS: "/get/all/past/news",
  GET_NEWS_BY_KEYWORD: "/get/news/by/keyword",
  GET_NEWS_KEYWORDS: "/get/news/keywords",

  // GET_ALL_CATEGORY: "/allCategory",

  // image upload
  UPLOAD_IMAGE: "/media/upload",
  DELETE_MEDIA_IMAGE: "/media/delete",

  // pdf upload
  UPLOAD_PDF: "/media/upload/pdf",
  DELETE_PDF: "/media/delete/pdf",

  // feedback
  SEND_FEEDBACK: "/send/feedback",

  // insight
  CREATE_INSIGHT: "/create/new/insight",

  // impression
  CREATE_NEWS_IMPRESSION: "/new/impression/news",
  CREATE_SITE_IMPRESSION: "/new/impression/site",

  //Advertisement
  CREATE_NEW_ADVERTISEMENT: "/create/new/advertisement",
  UPDATE_ADVERTISEMENT: "/update/advertisement",
  UPDATE_ADVERTISEMENT_STATUS: "/update/advertisement/status",
  DELETE_ADVERTISEMENT: "/delete/advertisement",
  GET_ALL_ADVERTISEMENT: "/get/advertisement",
  GET_ALL_ADVERTISEMENT_BY_PLACEMENT: "ad.js",

  //advertisement sub category
  GET_ALL_ADV_CATEGORY: "/get/all/advertisement/category",
  CREATE_ADV_CATEGORY: "/create/advertisement/main/category",
  UPDATE_ADV_SUB_CATEGORY: "/update/advertisement/sub/category",
  UPDATE_ADV_CATEGORY: "/update/advertisement/category/by",
  // UPDATE_ADV_SUPER_CATEGORY:
  GET_ALL_SUBCATEGORY: "/get/all/sub/category",

  //Jobs
  CREATE_NEW_JOB: "/create/new/jobs",
  GET_JOBS_BY_ID: "/get/job/by",
  GET_ALL_JOBS: "/get/all/jobs",
  UPDATE_JOBS: "/update/jobs",
  DOWNLOAD_APPLICATION: "/download/job/application",
  DELETE_JOBS: "/delete/jobs",
  GET_JOBS_BY_TAGS: "/get/related/jobs",
  ADD_JOB_COMMENT: "/add/job/comment",
  CHANGE_JOB_COMMENT_LIKE: "/change/job/comment/like",
  UPDATE_JOB_COMMENT_STATUS: "update/job/comment",
  DELETE_JOB_COMMENT: "delete/job/comment/by",
  GET_JOBS_BY_GAZETTE_DATE: "/get/jobs/by/gazette",
  GET_NEW_JOBS: "/get/new/jobs",

  //Gazette
  CREATE_NEW_GAZTTE: "/create/new/gazette",
  GET_ALL_GAZETTE: "/get/all/gazette",
  DELETE_GAZETTE: "/delete/gazette",
  DOWNLOAD_GAZETTE_APPLICATION: "/download/gazette/application",
  GET_GAZETTE_BY_GAZETTE_DATE: "/get/gazette/by/date",
  GET_GAZETTE_BY_GAZETTE_ID: "/get/gazette/by",
  GET_NEW_GAZETTE: "/get/new/date/gazette",

  //jobs impression
  CREATE_NEW_JOBS_IMPRESSION: "/new/impression/job/view",
  CREATE_NEW_JOBS_IMPRESSION_DOWNLOAD: "/new/impression/job/download",

  // gazette impression
  CREATE_NEW_GAZETTE_IMPRESSION: "/new/impression/gazette/view",

  //Jobs Category
  CREATE_NEW_JOBS_CATEGORY: "/create/jobs/category",
  GET_ALL_JOBS_CATEGORY: "/get/all/jobs/category",
  UPDATE_JOBS_CATEGORY: "/update/jobs/category",
  DELETE_JOBS_CATEGORY: "/delete/jobs/category",

  // tags
  CREATE_NEW_TAGS: "/create/new/tag",
  GET_ALL_TAGS: "/get/all/tags",
  UPDATE_TAGS: "/update/tag",
  DELETE_TAGS: "/delete/tag",

  // widget
  CREATE_WIDGET: "/create/widget",
  GET_ALL_WIDGET: "/get/all/widgets",
  UPDATE_WIDGET: "/update/widget",
  DELETE_WIDGET_NEWS: "/delete/widget/news",
  DELETE_WIDGET: "/delete/widget",

  // site-map
  GET_ALL_NEWS_URLS: "/get/all/news/urls",

  // live feed
  CREATE_NEW_LIVE_FEED: "/create/live/feed",
  GET_ALL_LIVE_FEED: "/get/all/live/feed",
  UPDATE_LIVE_FEED: "/update/live/feed",
  GET_TODAY_LIVE_FEED: "/get/today/live/feed",
  DELETE_LIVE_FEED: "/delete/live/feed",

  // ads sign up
  CREATE_NEW_COMPANY: "/create/new/company",
  CREATE_NEW_EMAIL_VERIFICATION: "/create/company/email/verification",
  RESEND_EMAIL_VERIFICATION: "/resend/company/email/verification",
  VERIFY_EMAIL: "/verify/company/email",

  //profile
  UPDATE_PROFILE: "/update/company",

  // SUBSCRIBE
  CREATE_NEW_SUBSCRIPTION: "/create/subscribe/news",

  // ads sign in
  ADS_SIGN_IN: "/ads/sign-in",
  EXISTING_USERNAME: "get/existing/by/email",
  UPDATE_USERNAME: "update/company/email",

  // data warehouse
  GET_CONNECTIONS: "/get/connection",
  CHECK_MYSQL_CONNECTION: "/check/mysql/connection",
  CHECK_MONGODB_CONNECTION: "/check/mongodb/connection",
  GET_TABLES: "/get/tables",
  GET_DATABASES: "/get/databases",
  CREATE_BACKUP: "/create/backup",
  CREATE_BACKUP_FULL: "/create/backup/all",
  GET_BACKUP_PROGRESS: "/backup/progress",
  GET_BACKUPS: "/get/backups",
  RESTORE_BACKUP: "/restore/backup",
  GET_RESTORE_PROGRESS: "/restore/progress",

  // paypal
  CREATE_ORDER: "/api/orders",
  APPROVE_ORDER: "api/orders",

  // Offers
  GET_TOP_OFFERS: "/get/top/offers",
};

export default ApiRoutes;
